export const calculateCorrectAnswers = (
  answer: string,
  rightAnswer: string,
  isOrder = false,
): number => {
  const answerArray = answer.split(',');
  const rightAnswerArray = rightAnswer.split(';');
  let correctCount = 0;
  if (isOrder) {
    rightAnswerArray.forEach((rightItem, index) => {
      const trimmedRightItem = rightItem.trim();
      if (
        index < answerArray.length &&
        answerArray[index].trim() === trimmedRightItem
      ) {
        correctCount++;
      }
    });
    return correctCount;
  } else {
    answerArray.forEach(answerItem => {
      if (rightAnswerArray.includes(answerItem.trim())) {
        correctCount++;
      }
    });
    return correctCount;
  }
};
